import ClinicSettingsDB from 'src/fb/clinicSettings-db';

/** @typedef {
 *   import('../../domain/entities/CareModelCohort.types').CareModelCohort
 * } CareModelCohort */

/**
 * Persist care model cohorts into clinic settings.
 *
 * @param {{ clinicId: string, careModelCohorts: CareModelCohort[] }} params
 * @returns {Promise<void>}
 */
// eslint-disable-next-line import/prefer-default-export
export async function saveCareModelCohorts({ clinicId, careModelCohorts }) {
  const clinicSettingsDb = new ClinicSettingsDB();
  await clinicSettingsDb.set({ careModelCohorts }, clinicId);
} // saveCareModelCohorts()
